<template>
  <BasePopup
    :visible="visible"
    :mask-closable="true"
    :show-close-btn="true"
    :show-confirm-btn="false"
    popup-class="create-popup"
    @close="handleClose"
  >
    <!-- 标题 -->
    <div class="create-popup-title"></div>

    <!-- 提示文案 -->
    <div class="create-popup-tips"></div>

    <!-- 按钮组 -->
    <div class="create-popup-buttons">
      <div class="create-popup-btn-cancel" @click="handleCancel"></div>
      <div class="create-popup-btn-confirm" @click="handleConfirm"></div>
    </div>
  </BasePopup>
</template>

<script setup>
import BasePopup from './BasePopup.vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:visible', 'close', 'confirm', 'cancel']);

const handleClose = () => {
  emit('update:visible', false);
  emit('close');
};

const handleConfirm = () => {
  emit('confirm');
  emit('update:visible', false);
};

const handleCancel = () => {
  emit('cancel');
  emit('update:visible', false);
};
</script>

<style scoped lang="less">
</style>
